
import React from "react";


const Card = ({
    heading, 
    children, 
    CardHeaderClass="card-header fw-semibold",
    CardRowClass="row g-3 pb-3"
}) => {
    
    return (
        <>
            <div className="card">
                {
                    heading && (
                        <div className={CardHeaderClass}>{heading}</div>
                    )
                }
                {
                    children && (
                        <div className="card-body">
                            <div className={CardRowClass}>
                                {children}
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default Card;